import * as React from 'react';
export var ProjectCard = function (_a) {
    var title = _a.title, category = _a.category, description = _a.description, partner = _a.partner, _b = _a.technologies, technologies = _b === void 0 ? [] : _b, children = _a.children;
    return (React.createElement("div", { className: "card project-card" },
        React.createElement("div", { className: "text-box text-card-content" },
            React.createElement("span", { className: "headline" }, category),
            React.createElement("h2", { className: "headline" }, title),
            React.createElement("p", null, description),
            React.createElement("div", { className: "tech-logos" }, technologies.map(function (_a) {
                var id = _a.id, image = _a.image, name = _a.name;
                return (React.createElement("div", { key: id, className: "tech-logo" },
                    React.createElement("img", { src: image, alt: id, title: name })));
            })),
            children),
        partner && (React.createElement("div", { className: "partner-logo" },
            React.createElement("img", { src: partner.image, alt: "Partner", title: partner.name })))));
};
//# sourceMappingURL=index.js.map